export const LS_REFRESH_TOKEN = 'dokia_refresh_token';
export const LS_TRUSTED_DEVICE_TOKEN = 'dokia_trusted_device_token';

export function clearStoredAuthTokens(): void {
  localStorage.removeItem(LS_REFRESH_TOKEN);
  localStorage.removeItem(LS_TRUSTED_DEVICE_TOKEN);
}

export function getStoredRefreshToken(): string | undefined {
  return localStorage.getItem(LS_REFRESH_TOKEN) ?? undefined;
}

export function getStoredTrustedDeviceToken(): string | undefined {
  return localStorage.getItem(LS_TRUSTED_DEVICE_TOKEN) ?? undefined;
}

export function setStoredAuthTokens(tokens: {
  refreshToken: string;
  trustedDeviceToken: string;
}): void {
  localStorage.setItem(LS_REFRESH_TOKEN, tokens.refreshToken);
  localStorage.setItem(LS_TRUSTED_DEVICE_TOKEN, tokens.trustedDeviceToken);
}

export function setStoredRefreshToken(refreshToken: string): void {
  localStorage.setItem(LS_REFRESH_TOKEN, refreshToken);
}
